import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M20.53 8.46C18.57 6.52 15.39 6.52 13.43 8.46L8.45 13.41C7.66 14.19 6.38 14.19 5.59 13.41C5.21 13.03 5 12.53 5 12C5 11.47 5.21 10.97 5.59 10.59C5.98 10.2 6.5 10 7.02 10C7.54 10 8.06 10.2 8.45 10.59L9.16 11.3L11.29 9.18L10.57 8.46C8.61 6.52 5.43 6.52 3.47 8.46C2.52 9.41 2 10.66 2 12C2 13.34 2.52 14.59 3.47 15.54C4.45 16.51 5.74 17 7.02 17C8.31 17 9.59 16.51 10.57 15.54L15.55 10.59C16.34 9.81 17.62 9.8 18.41 10.59C18.79 10.97 19 11.47 19 12C19 12.53 18.79 13.03 18.41 13.41C17.62 14.2 16.34 14.2 15.55 13.41L14.84 12.7L12.71 14.82L13.43 15.54C14.41 16.51 15.69 17 16.98 17C18.26 17 19.55 16.51 20.53 15.54C21.48 14.59 22 13.34 22 12C22 10.66 21.48 9.41 20.53 8.46Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Infinity');

export default Icon;
